import { render } from "./ReservationRequestEdit.vue?vue&type=template&id=1dd0b764&ts=true"
import script from "./ReservationRequestEdit.vue?vue&type=script&lang=ts"
export * from "./ReservationRequestEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__